<mat-card
    appearance="outlined"
    class="provider-card"
    fxLayout="column"
    fxLayoutAlign="space-between"
    *transloco="let t"
    [ngClass]="{ added: provider.selected }"
    [title]="provider.name"
>
    <div fxLayout="row wrap" fxLayoutAlign="space-between center">
        @if (provider.webSite) {
        <a
            [href]="provider.webSite"
            target="_blank"
            rel="noopener"
            style="text-decoration: unset"
        >
            <ng-container *ngTemplateOutlet="header"></ng-container>
        </a>
        } @else {
        <mat-card-header class="provider-card-header">
            <img
                class="provider-card-image"
                mat-card-avatar
                src="{{
                    provider.logoPath
                        ? provider.logoPath
                        : 'https://placeholder.pics/svg/300/DEDEDE/FFFFFF-FFFFFF'
                }}"
                [alt]="provider.name"
            />
            <mat-card-title class="{{ provider.webSite ? 'title-link' : '' }}">
                {{ provider.name }}
                @if (provider.webSite) {
                <mat-icon>open_in_new</mat-icon>
                }
            </mat-card-title>
        </mat-card-header>
        }
        <ng-template #header>
            <mat-card-header class="provider-card-header">
                <img
                    class="provider-card-image"
                    mat-card-avatar
                    src="{{
                        provider.logoPath
                            ? provider.logoPath
                            : 'https://placeholder.pics/svg/300/DEDEDE/FFFFFF-FFFFFF'
                    }}"
                    [alt]="provider.name"
                />
                <mat-card-title
                    class="{{ provider.webSite ? 'title-link' : '' }}"
                >
                    {{ provider.name }}
                    @if (provider.webSite) {
                    <mat-icon>open_in_new</mat-icon>
                    }
                </mat-card-title>
            </mat-card-header>
        </ng-template>
        <mat-card-content class="provider-card-content">
            <p class="description" [innerHTML]="provider.description"></p>
            @if ( (provider?.countiesServed ?? []).length === 0 &&
            (provider?.sites ?? []).length === 0 ) {
            <span>
                @if (!provider.isWaitlist) {
                <mat-list class="provider-programs-list" dense>
                    @for (program of provider.programs; track program) {
                    <mat-list-item class="provider-programs-list-item">
                        <mat-icon class="list-item-check-icon" matListIcon
                            >check</mat-icon
                        >
                        <span>{{ program.name }}</span>
                    </mat-list-item>
                    }
                </mat-list>
                }
            </span>
            } @if ( (provider?.countiesServed ?? []).length > 0 ||
            (provider?.sites ?? []).length > 0 ) {
            <mat-expansion-panel class="provider-expansion-panel">
                <mat-expansion-panel-header
                    class="provider-expansion-panel-header"
                >
                    <mat-panel-title>
                        <span>{{ t("provider.programs-offered") }}</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-list dense>
                    @for (program of provider.programs; track program) {
                    <mat-list-item>
                        <mat-icon class="list-item-check-icon" matListIcon
                            >check</mat-icon
                        >
                        <span>{{ program.name }}</span>
                    </mat-list-item>
                    }
                </mat-list>
            </mat-expansion-panel>
            } @if ((provider?.countiesServed ?? []).length > 0) {
            <mat-expansion-panel class="provider-expansion-panel">
                <mat-expansion-panel-header
                    class="provider-expansion-panel-header"
                >
                    <mat-panel-title>
                        <span>{{ t("provider.counties-served") }}</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-list dense>
                    @for (county of provider.countiesServed; track county) {
                    <mat-list-item>
                        <mat-icon class="list-item-check-icon" matListIcon
                            >check</mat-icon
                        >
                        <span>{{ county }}</span>
                    </mat-list-item>
                    }
                </mat-list>
            </mat-expansion-panel>
            } @if ((provider?.sites ?? []).length > 0 && !provider.selected) {
            <mat-expansion-panel class="provider-expansion-panel">
                <mat-expansion-panel-header
                    class="provider-expansion-panel-header"
                >
                    <mat-panel-title>
                        <span>{{ t("provider.locations") }}</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-list class="provider-expansion-panel-list" dense>
                    @for (site of provider.sites; track site) {
                    <mat-list-item class="provider-expansion-panel-list-item">
                        <div
                            fxFlex="100%"
                            fxLayout="row"
                            fxLayoutAlign="start center"
                            wrap
                        >
                            <mat-icon matListIcon class="list-item-check-icon"
                                >check</mat-icon
                            >
                            @if (provider.address) {
                            <a
                                href="https://maps.google.com/?q={{
                                    singleLineAddress(site)
                                }}"
                                target="_blank"
                                rel="noopener"
                                matTooltip="{{ singleLineAddress(site) }}"
                                class="location-link"
                            >
                                {{ site.streetAddress }}<br />
                                {{ site.city }}, {{ site.stateCode }}
                                {{ site.postalCode }}
                            </a>
                            }
                        </div>
                    </mat-list-item>
                    }
                </mat-list>
            </mat-expansion-panel>
            }
        </mat-card-content>
    </div>
    <div fxLayout="column" class="footer-container">
        @if ((provider?.sites ?? []).length > 0 && provider.selected) {
        <div class="site-selector-wrapper">
            <app-provider-site-selector
                [sites]="provider.sites"
                [selectedSiteIds]="provider.selectedSiteIds"
                (selectedSiteIdsChange)="updateSelectedSites($event)"
            ></app-provider-site-selector>
        </div>
        }
        <mat-divider></mat-divider>
        <mat-card-footer
            fxLayout="row"
            fxLayoutAlign="space-around center"
            class="provider-footer"
        >
            @if (provider.isWaitlist) {
            <div style="margin-left: auto"></div>
            } @if (!provider.isWaitlist) {
            <div>
                @if (provider.address) {
                <a
                    href="https://maps.google.com/?q={{
                        singleLineAddress(provider.address)
                    }}"
                    target="_blank"
                    rel="noopener"
                    matTooltip="{{ singleLineAddress(provider.address) }}"
                >
                    {{ singleLineAddress(provider.address) }}
                    <mat-icon>open_in_new</mat-icon>
                </a>
                }
            </div>
            }
            <button
                mat-button
                [ngClass]="
                    provider.selected ? 'mat-flat-button' : 'mat-stroked-button'
                "
                color="primary"
                (click)="toggleSelected()"
                name="Select Provider"
                id="{{ 'provider-' + provider.providerId + '-button' }}"
            >
                @if (provider.selected) {
                <mat-icon>check</mat-icon>
                }
                {{
                    (provider.selected
                        ? t("provider.added")
                        : t("provider.select")
                    ) | uppercase
                }}
            </button>
        </mat-card-footer>
    </div>
</mat-card>
